// src/functions/portalDocsApi.js
// Authenticated portal-client document actions, separate from the public
// share-link flow in api_fethcers.js.

import { apiAxios } from "./axiosInstance";

// POST /api/documents/{document_id}/record-open
// Explicit signal that the logged-in client opened one of their own documents,
// so the first-view Telegram notification names the client instead of
// defaulting to anonymous. Ownership is enforced server-side (403 otherwise).
export const recordDocumentOpen = async (documentId) => {
  const response = await apiAxios.post(`/documents/${documentId}/record-open`);
  return response.data;
};
